import React from 'react';
import clx from "classnames";
import { FiCheck, FiMoreHorizontal,  FiUsers, FiVolume2 } from 'react-icons/fi'
import {FaThumbtack} from 'react-icons/fa'
import { users } from '../../../../dummy/users';
import messengerStore from '../../../../stores/useMessenger';

const Users = () => {
    const [selected, setSelected] = React.useState(0);
    const {setConversation} = messengerStore(state=>state)
  
    return (
       
      <ul>
      {users.map((message,i)=>(
            <li 
            onClick={()=>{
              setSelected(message.id)
              setConversation(i)
            }}
            key={`user-${i}`} className={clx(selected==message.id&&'rounded-xl overflow-hidden m-2')} 
            >
              <div
                className={
                  clx(`group relative flex justify-between 
                  items-end p-3 dark:border-black/30  cursor-pointer`,
                  selected===message.id ? 'bg-blue-500 text-white' : 'hover:bg-gray-200 dark:hover:bg-zinc-700 ',
                  i+1!=users.findIndex(f=>f.id==selected) && 'border-b'
                  )
                }
              >
                <div className='hidden'>
                    <div
                      className="group-hover:block hidden absolute right-2 top-2"
                    >
                    <FiMoreHorizontal className="text-gray-400" />
                    </div>
                  {/** Dropdown **/}
                </div>
  
                <div className="flex gap-2">
                  <div>
                    <img
                      src={message.avatar}
                      className="h-12 w-12 object-contain"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-1">
                      {message.group && <FiUsers className="h-4" /> }
                      {message.sound && <FiVolume2 className="h-4" /> }
                      <div className="font-medium">{message.name}</div>
                    </div>
                    {!message.typing && <p className="text-sm opacity-50"> {message.message} </p>}
                    {message.typing && <p className={clx('text-sm font-bold', message.id!=selected && 'text-green-600')}>Typing...</p>}
  
                  </div>
                </div>
                <div className="flex items-end flex-col gap-1">
                  <div className="date flex">
                    <div className="readed -mr-1">
                      <FiCheck className="text-green-500 h-3" />
                      <FiCheck className="text-green-500 h-3 -mt-2" />
                    </div>
                    <p className="text-xs opacity-50">{message.date}</p>
                  </div>
                  {message.count && (
                  <div className="badge w-4 h-4 text-xs flex items-center justify-center rounded-full bg-blue-500 text-white font-bold">
                    {message.count}
                  </div>
                )}
                {message.pinned && <FaThumbtack className="h-4" color={selected===message.id?'white':'gray'} />}
                </div>
              </div>
            </li>
      ))}
  </ul>
    )
}

export default Users;